import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LocalStorageService } from 'services';
import { AppConstants } from 'constants/index';
import { UserConfig, UserConfigs, UserPreferencesState } from 'app/userPreferences/types';

const getInitialState = (): UserPreferencesState => ({
  configs: {
    pageSize: AppConstants.pageSize,
    languageId: AppConstants.defaultLanguage,
    campaignsPageSize: AppConstants.pageSize,
    playersPageSize: AppConstants.pageSize,
    ...LocalStorageService.get('configs'),
  },
  current: LocalStorageService.get('current') || {},
});

const slice = createSlice({
  name: 'userPreferences',
  initialState: getInitialState,
  reducers: {
    saveUserConfigs: (state, action: PayloadAction<UserConfigs>) => {
      state.configs = action.payload;
    },
    saveUserConfigKey: (state, action: PayloadAction<UserConfig>) => {
      const { key, configValue } = action.payload;
      Object.assign(state.configs, { [key]: configValue });
    },
    setCurrentBrandId: (state, action: PayloadAction<number | undefined>) => {
      state.current.brandId = action.payload;
    },
    setCurrentPartnerId: (state, action:PayloadAction<number>) => {
      state.current.partnerId = action.payload;
    },
    setCurrentConversionId: (state, action:PayloadAction<string | undefined>) => {
      state.current.conversionId = action.payload;
    },
  },
});

export const {
  saveUserConfigs, saveUserConfigKey, setCurrentBrandId, setCurrentPartnerId, setCurrentConversionId,
} = slice.actions;

export default slice.reducer;
